import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ObjectSchema } from "yup";

import {
  errors,
  isBeforeTimeString,
  TTimeHHmm,
  yupLocalized,
} from "@ryde/shared";

import { IAvailabilityItem } from "./table-availability.models";

export const useAvailabilityItemResolver = () => {
  const { t } = useTranslation();

  //TODO: formAttributes?.disallowOvernight  was used, but it was switching off completely all checks, enable it if needed
  const availabilityInnerFormValidationSchema: ObjectSchema<
    Partial<IAvailabilityItem>
  > = useMemo(() => {
    return yupLocalized.object<Partial<IAvailabilityItem>>().shape({
      dayTypeIds: yupLocalized
        .array()
        .test(
          "requiredCustomOneOf",
          t(errors.validation.requiredCustomOneOf),
          (dayTypeIds, ctx) => {
            const { dayGroupIds } = ctx.parent;
            return (
              (dayTypeIds && dayTypeIds.length > 0) ||
              (dayGroupIds && dayGroupIds.length > 0)
            );
          },
        ),
      dayGroupIds: yupLocalized
        .array()
        .test(
          "requiredCustomOneOf",
          t(errors.validation.requiredCustomOneOf),
          (dayGroupIds, ctx) => {
            const { dayTypeIds } = ctx.parent;
            return (
              (dayGroupIds && dayGroupIds.length > 0) ||
              (dayTypeIds && dayTypeIds.length > 0)
            );
          },
        ),
      from: yupLocalized
        .string()
        .required()
        .test(
          "isBeforeTest",
          t(errors.validation.endTimeMustBeGreaterThenStartTime),
          (from, ctx) => {
            const { to } = ctx.parent;
            return isBeforeTimeString(from as TTimeHHmm, to as TTimeHHmm);
          },
        ),
      to: yupLocalized
        .string()
        .required()
        .test(
          "isBeforeTest",
          t(errors.validation.endTimeMustBeGreaterThenStartTime),
          (to, ctx) => {
            const { from } = ctx.parent;
            return isBeforeTimeString(from as TTimeHHmm, to as TTimeHHmm);
          },
        ),
    }) as ObjectSchema<Partial<IAvailabilityItem>>;
  }, [t]);
  return { availabilityInnerFormValidationSchema };
};
